import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  FDEmphasisSurface, FDIcon, FDTooltip, tokens,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { pillarToOutlinedIcon, pillarToFilledIcon } from 'Consts/pillars';


const useStyles = buildUseStyles('PillarProgressIcon', () => ({
  icon: {
    '& svg': {
      fontSize: ({ isMobile }) => (isMobile ? undefined : '32px'),
    },
  },
  iconOrange: {
    '& svg': {
      color: tokens.color_sunset_500,
    },
  },
}));


const mapping = {
  todo: (id) => {
    return pillarToOutlinedIcon[id] || 'circleOutline';
  },
  completed: (id) => {
    return pillarToFilledIcon[id] || 'circle';
  },
  reward: (id) => {
    const map = {
      reward: 'star',
    };

    return map[id] || 'star';
  },
};

export const PillarProgressItem = ({ resource: itemResource }) => {
  const icon = mapping[itemResource.attr('type')](itemResource.id());
  const isReward = itemResource.attr('type') === 'reward';
  const isMobile = useMobileLayout();
  const classes = useStyles({ isMobile });

  return (
    <FDEmphasisSurface>
      <div className={classNames(classes.icon, { [classes.iconOrange]: isReward })}>
        <FDTooltip title={itemResource.attr('name')}>
          <FDIcon icon={icon} color={'textPrimary'} />
        </FDTooltip>
      </div>
    </FDEmphasisSurface>
  );
};

PillarProgressItem.defaultProps = {
};

PillarProgressItem.propTypes = {
  resource: PropTypes.object.isRequired,
};
